'use client';

import { reatomContext, useCreateCtx } from '@reatom/npm-react';
import { FcmTokenProvider } from '@trwl/provider/fcmTokenProvider';
import { LoadDataProvider } from '@trwl/provider/loadDataProvider';
import { PropsWithChildren } from 'react';

export const Providers = ({ children }: PropsWithChildren) => {
  const ctx = useCreateCtx();

  return (
    <reatomContext.Provider value={ctx}>
      <FcmTokenProvider>
        <LoadDataProvider>{children}</LoadDataProvider>
      </FcmTokenProvider>
    </reatomContext.Provider>
  );
};
